import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

export class SimapAuthInterceptor implements HttpInterceptor {
  constructor(private apiUrl: string) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!this.apiUrl) return next.handle(request);

    if (this.isSimapApiUrl(request)) {
      const token = sessionStorage.getItem('access_token') ?? '';
      return this.processRequestWithToken(token, request, next);
    }

    return next.handle(request);
  }

  private processRequestWithToken(
    token: string,
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (token) {
      req = req.clone({
        setHeaders: {
          Simap: `${token}`,
        },
      });
    }

    return next.handle(req);
  }

  private isSimapApiUrl(req: HttpRequest<unknown>): boolean {
    return (
      req.method !== 'OPTIONS' &&
      req.method !== 'GET' &&
      req.url.startsWith(`${this.apiUrl}/Tender`) &&
      req.url.includes(`/Simap/`)
    );
  }
}
